import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Observable } from 'rxjs';
import { CallableFunction } from '../../resources/app-firebase';
import { CommonIdGetDesiredUniversitiesRequest } from 'src/app/models/common-id/common-id-get-desired-universities-request';
import { CommonIdGetDesiredUniversitiesResponse } from 'src/app/models/common-id/common-id-get-desired-universities-response';

@Injectable({
  providedIn: 'root'
})
export class CommonIdGetDesiredUniversitiesService {
  constructor(private aff: AngularFireFunctions) {}

  commonIdGetDesiredUniversities(request: CommonIdGetDesiredUniversitiesRequest): Observable<CommonIdGetDesiredUniversitiesResponse> {
    const callable = this.aff.httpsCallable(CallableFunction.COMMON_ID_GET_DESIRED_UNIVERSITIES);
    return callable(request);
  }
}
